import { lazy } from "react";
import { withSuspense } from "./routeHelpers";

const InterestsRoot = lazy(
  () => import(/* webpackChunkName: "interests" */ "../Interests/InterestsRoot")
);
const Interests = lazy(
  () => import(/* webpackChunkName: "interests" */ "../Interests/Interests")
);
const Assignments = lazy(
  () => import(/* webpackChunkName: "interests" */ "../Interests/Assignments")
);
const Tracking = lazy(
  () => import(/* webpackChunkName: "interests" */ "../Interests/Tracking")
);

export default [
  {
    element: withSuspense(InterestsRoot),
    children: [
      {
        path: "/interests",
        element: withSuspense(Interests),
        id: "interests",
      },
      {
        path: "/interests/assignments",
        element: withSuspense(Assignments),
        id: "assignments",
      },
      {
        path: "/interests/tracking",
        element: withSuspense(Tracking),
        id: "tracking",
      },
    ],
  },
];
